import { render, staticRenderFns } from "./profile-cv.vue?vue&type=template&id=3c70c4bd"
import script from "./profile-cv.vue?vue&type=script&lang=js"
export * from "./profile-cv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports